import { combineReducers } from 'redux';
import simuladorFVGSlice from './simuladorFVGSlice';

export default combineReducers({
    simuladorFVG : simuladorFVGSlice
});